import { defineComponent as C, ref as g, provide as y, h as l, Fragment as L, Teleport as S, reactive as x } from "vue";
import { NotificationContainer as N } from "./ghl-ui.es1059.js";
import { NotificationEnvironment as P } from "./ghl-ui.es1060.js";
import { notificationProviderInjectionKey as I } from "./ghl-ui.es1061.js";
import K from "./ghl-ui.es1062.js";
import H from "./ghl-ui.es854.js";
import b from "./ghl-ui.es855.js";
import { omit as w } from "./ghl-ui.es1058.js";
import { createInjectionKey as T } from "./ghl-ui.es896.js";
import { createId as _ } from "./ghl-ui.es939.js";
import B from "./ghl-ui.es1063.js";
const E = T("n-notification-api"), z = Object.assign(Object.assign({}, b.props), {
  containerClass: String,
  containerStyle: [String, Object],
  to: [String, Object],
  scrollable: {
    type: Boolean,
    default: !0
  },
  max: Number,
  placement: {
    type: String,
    default: "top-right"
  },
  keepAliveOnHover: Boolean
}), X = C({
  name: "NotificationProvider",
  props: z,
  setup(r) {
    const {
      mergedClsPrefixRef: s
    } = H(r), e = g([]), n = {}, t = /* @__PURE__ */ new Set();
    function c(i) {
      const o = _(), f = () => {
        t.add(o), n[o] && n[o].hide();
      }, u = x(Object.assign(Object.assign({}, i), {
        key: o,
        destroy: f,
        hide: f,
        deactivate: f
      })), {
        max: p
      } = r;
      if (p && e.value.length - t.size >= p) {
        let v = !1, h = 0;
        for (const m of e.value) {
          if (!t.has(m.key)) {
            n[m.key] && (m.destroy(), v = !0);
            break;
          }
          h++;
        }
        v || e.value.splice(h, 1);
      }
      return e.value.push(u), u;
    }
    const a = ["info", "success", "warning", "error"].map((i) => (o) => c(Object.assign(Object.assign({}, o), {
      type: i
    })));
    function O(i) {
      t.delete(i), e.value.splice(e.value.findIndex((o) => o.key === i), 1);
    }
    const j = b("Notification", "-notification", K, B, r, s), d = {
      create: c,
      info: a[0],
      success: a[1],
      warning: a[2],
      error: a[3],
      open: A,
      destroyAll: R
    }, k = g(0);
    y(E, d), y(I, {
      props: r,
      mergedClsPrefixRef: s,
      mergedThemeRef: j,
      wipTransitionCountRef: k
    });
    function A(i) {
      return c(i);
    }
    function R() {
      Object.values(e.value).forEach((i) => {
        i.hide();
      });
    }
    return Object.assign({
      mergedClsPrefix: s,
      notificationList: e,
      notificationRefs: n,
      handleAfterLeave: O
    }, d);
  },
  render() {
    var r, s, e;
    const {
      placement: n
    } = this;
    return l(L, null, (s = (r = this.$slots).default) === null || s === void 0 ? void 0 : s.call(r), this.notificationList.length ? l(S, {
      to: (e = this.to) !== null && e !== void 0 ? e : "body"
    }, l(N, {
      class: this.containerClass,
      style: this.containerStyle,
      scrollable: this.scrollable && n !== "top" && n !== "bottom",
      placement: n
    }, {
      default: () => this.notificationList.map((t) => l(P, Object.assign({
        ref: (c) => {
          const a = t.key;
          c === null ? delete this.notificationRefs[a] : this.notificationRefs[a] = c;
        }
      }, w(t, ["destroy", "hide", "deactivate"]), {
        internalKey: t.key,
        onInternalAfterLeave: this.handleAfterLeave,
        keepAliveOnHover: t.keepAliveOnHover === void 0 ? this.keepAliveOnHover : t.keepAliveOnHover
      })))
    })) : null);
  }
});
export {
  X as default,
  E as notificationApiInjectionKey,
  z as notificationProviderProps
};
